const DesktopTable = ({ packingDetails }) => {
  return (
    <table className="responsiveTable hidden lg:table">
      <thead>
        <tr>
          <th>Product</th>
          <th>Size (mm)</th>
          <th>Thickness (mm)</th>
          <th>Tiles / Box (pcs.)</th>
          <th>Coverage Area / Box (sq ft)</th>
        </tr>
      </thead>
      <tbody>
        {packingDetails.map((detail, index) => (
          <tr key={index}>
            {/* Apply rowspan for the product name only in the first row */}
            {index === 0 && (
              <td data-label="Product" rowSpan={packingDetails.length}>
                {detail.product_name || "NA"}
              </td>
            )}
            <td data-label="Size">{detail.size || "NA"}</td>
            <td data-label="Thickness">{detail.thickness || "NA"}</td>
            <td data-label="Tiles / Box">{detail.tiles_per_box || "NA"}</td>
            <td data-label="Coverage Area / Box">{detail.area_per_box || "NA"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DesktopTable;
